import { Tooltip, Typography } from '@mui/material';

import { NO_VALUE } from '../copy';
import { STATUS_DATE_UNAVAILABLE, statusAge } from '../statusAge';
import type { PayerState } from '../types';

export interface StatusAgeLineProps {
  statusUpdatedAt?: string | null;
  /** Reference instant for the elapsed time; `status_updated_at` stays the anchor. */
  asOf: Date;
  /** The folded state the age belongs to; carried for callers that vary by state. */
  state: PayerState;
}

const ageSx = { fontSize: '13px', color: '#6b6b78', whiteSpace: 'nowrap' } as const;

/**
 * How long the row has been waiting: "9 days", with the date it entered the
 * status and the exact timestamp on hover. A row with no reliable anchor
 * shows an em dash rather than a made-up zero — the footnote under the table
 * says why.
 */
export function StatusAgeLine({ statusUpdatedAt, asOf }: StatusAgeLineProps) {
  const age = statusAge(statusUpdatedAt, asOf);
  if (!age) {
    return (
      <Tooltip title={STATUS_DATE_UNAVAILABLE}>
        <Typography component="span" aria-label={STATUS_DATE_UNAVAILABLE} sx={ageSx}>
          {NO_VALUE}
        </Typography>
      </Tooltip>
    );
  }
  return (
    <Typography component="span" title={`Since ${age.since} · ${age.exact}`} sx={ageSx}>
      {age.elapsed}
    </Typography>
  );
}
